// src/app/components/terms-blocker/terms-blocker.component.ts
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import {
  IonButton,
  IonContent,
  IonHeader,
  IonSpinner,
  IonText,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';

import { Observable } from 'rxjs';

import { NetworkService } from '../../services/core/network.service';
import { ProfileService } from '../../services/account/profile.service';
import { Terms, TermsService } from '../../services/account/terms.service';

import { MarkdownModule } from 'ngx-markdown';

@Component({
  selector: 'app-terms-blocker',
  standalone: true,
  imports: [
    IonButton,
    IonContent,
    IonHeader,
    IonSpinner,
    IonText,
    IonTitle,
    IonToolbar,
    
    CommonModule,
    MarkdownModule,
  ],
  templateUrl: './terms-blocker.component.html',
  styleUrls: ['./terms-blocker.component.scss'],
})
export class TermsBlockerComponent implements OnInit {
  terms$!: Observable<Terms | null>;
  accepting = false;
  online$!: Observable<boolean>;

  constructor(
    private termsService: TermsService,
    private profileService: ProfileService,
    private networkService: NetworkService,
  ) { }

  ngOnInit() {
    this.terms$ = this.termsService.latestTerms$;
    this.online$ = this.networkService.online$;
  }

  async accept() {
    if (this.accepting) return;
    this.accepting = true;

    try {
      await this.termsService.acceptLatest();   // 👈 await instead of subscribe()
      // optionally refresh profile here...
      await this.profileService.refreshUser();
    } catch (err) {
      console.error('Error accepting terms', err);
    } finally {
      this.accepting = false;
    }
  }

  logout() {
    // TODO: your logout logic here
  }
}
